import React from 'react';
import { Grid } from '@mui/material';
import CustomAccordion from '../ui/CustomAccordion';
import InfoField from './InfoField';

interface FieldConfig {
  id: string;
  name: string;
  displayName: string;
  fields: {
    ExpandedViewItemKey: { value: string };
    ExpandedViewItemLabel: { value: string };
  };
}

interface CaregiverInformationProps {
  caregiver?: Record<string, any>;
  fieldConfigs?: FieldConfig[];
  headerText?: string;
}

const CaregiverInformationSection: React.FC<CaregiverInformationProps> = ({
  caregiver,
  fieldConfigs,
  headerText,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!caregiver) return null;

  // Default field configurations if not provided from Sitecore
  const defaultFields = [
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'phoneNumber', label: 'Phone Number' },
    { key: 'gender', label: 'Gender' },
    { key: 'address', label: 'Address' },
  ];

  // Use Sitecore field configs if available, otherwise use defaults
  const fields = fieldConfigs
    ? fieldConfigs.map((config) => ({
        key: config.fields.ExpandedViewItemKey.value,
        label: config.fields.ExpandedViewItemLabel.value,
      }))
    : defaultFields;

  return (
    <CustomAccordion
      title={headerText || 'Caregiver Information'}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        mt: 1,
        '& .MuiAccordionSummary-root': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-root.Mui-expanded': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-content': {
          margin: '0 !important',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: '0 !important',
        },
      }}
      detailsSx={{ py: 1, px: 2 }}
    >
      <Grid container spacing={1.5}>
        {fields.map((field, index) => (
          <Grid item xs={12} sm={6} md={3} key={field.key || index}>
            <InfoField label={field.label} value={caregiver[field.key]} />
          </Grid>
        ))}
      </Grid>
    </CustomAccordion>
  );
};

export default CaregiverInformationSection;
